export var ScrollColor;
(function (ScrollColor) {
    ScrollColor["background"] = "rgba(255, 255, 255, .15)";
    ScrollColor["indicator"] = "rgba(155, 155, 155, .7)";
})(ScrollColor || (ScrollColor = {}));
//# sourceMappingURL=colors.js.map